const highlightSuggestion = (sentence: string, substring: string) => {
  const trimmedSubstring = substring.trim();
  if (!trimmedSubstring.trim()) {
    return sentence;
  }

  return sentence.replace(new RegExp(`(${trimmedSubstring.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi'), '**$1**');
};

export default highlightSuggestion;
